/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GuideCreateRequest = core.serialization.object({
    description: core.serialization.string(),
    title: core.serialization.string(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    slug: core.serialization.string(),
    blocks: core.serialization.list(core.serialization.record(core.serialization.string(), core.serialization.any()).optional()),
    environmentId: core.serialization.string(),
});
